import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

import { Button } from 'components/Button';
import { Headline } from 'components/Headline';
import { Input } from 'components/Input';

const Container = styled.div`
  width: 50rem;
  min-height: 50rem;
  padding: 6.4rem;

  background-color: ${pickColor('transparentWhiteBackground')};
  backdrop-filter: blur(0.8rem);

  ${mediaMinWidth.md(css`
    width: auto;

    margin: 0 2rem;
    padding: 3rem;
  `)}
`;

const MessageContainer = styled.div`
  margin-bottom: 4.8rem;
`;

const ErrorMessage = styled.p`
  margin-bottom: 0.4rem;

  color: ${pickColor('red')};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ForgotPassword = styled(Button)`
  align-self: flex-end;

  margin-bottom: 2.4rem;
`;

const Title = styled(Headline)`
  margin-bottom: 1.2rem;
`;

const LoginInput = styled(Input)`
  margin-bottom: 2.4rem;
`;

const Form = styled.form``;

export {
  Container,
  Wrapper,
  Title,
  LoginInput,
  Form,
  MessageContainer,
  ErrorMessage,
  ForgotPassword,
};
